import { getToken, removeToken, isLoggedOn } from "../auth-context";

export default {
    getToken,
    removeToken,
    isLoggedOn
};


// WEBPACK FOOTER //
// ./src/store/auth.ts